import React from 'react';
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, RadioGroupProps, FormHelperText } from '@material-ui/core'; // Import FormHelperText for error message
import { useTranslation } from 'react-i18next';

import type { OptionType } from 'components/SGSSelect';
import { Controller, FieldError, useController, useFormContext } from 'react-hook-form';

type TriggerByName = {
    trigger: Function;
    name: string;
};
export type SGSRadioProps = RadioGroupProps & {
    label?: string;
    options: OptionType<string>[];
    handleChange?: Function;
    disabled?: boolean;
    trigger?: Function;
    triggerByName?: TriggerByName;
    diabledOpts?: any[];
    readOnly?: boolean;
};

const SGSRadioCtr: React.FC<SGSRadioProps> = ({ name, options, label, handleChange, disabled = false, trigger, triggerByName, diabledOpts, readOnly, ...props }) => {
    const { control, getValues } = useFormContext();
    const { t } = useTranslation();

    const isOptDisabled = (value) => {
        if (disabled) return true;
        if (diabledOpts) {
            return diabledOpts.includes(value);
        }
        return false;
    };

    const { fieldState } = useController({
        control,
        name,
        rules: { required: true }, // Add required rule
    });

    const { error } = fieldState as { error?: FieldError }; //

    const value = getValues(name);

    return (
        <FormControl component="fieldset" fullWidth error={!!error}>
            <FormLabel component="legend" error={!!error}>
                {t(label)}
            </FormLabel>
            <Controller
                rules={{ required: true }}
                control={control}
                name={name}
                render={({ field: { onChange }, fieldState: { error } }) => {
                    const errorMsg = error?.message ?? null;
                    return (
                        <>
                            <RadioGroup
                                aria-label={t(label)}
                                name={name}
                                id={name}
                                {...props}
                                value={value || ''} // Set default value here
                                onChange={(e) => {
                                    if (!readOnly) {
                                        onChange(e.target.value);
                                        if (handleChange) handleChange(e.target.value);
                                        if (trigger) trigger(name);
                                        if (triggerByName) triggerByName.trigger(triggerByName.name);
                                    }
                                }}
                            >
                                {options.map((opt) => (
                                    <FormControlLabel
                                        disabled={isOptDisabled(opt.value)}
                                        key={opt.value}
                                        value={opt.value}
                                        control={<Radio />}
                                        label={typeof opt.label === 'string' ? t(opt.label) : opt.label}
                                    />
                                ))}
                            </RadioGroup>
                            {errorMsg && <FormHelperText style={{ color: '#eb4c37' }}>{errorMsg}</FormHelperText>}
                        </>
                    );
                }}
            />
        </FormControl>
    );
};

export default SGSRadioCtr;
